/* Copyright 2013 - 2024 Waiterio LLC */
import getApiUrl from '@multilocale/shared/getApiUrl.js'
import {
  getAccessToken,
  isAccessTokenExpired,
  setAccessToken,
} from './accessToken.js'
import {
  getRefreshToken,
  isRefreshTokenExpired,
  setRefreshToken,
} from './refreshToken.js'

export default async function refreshAccessToken() {
  let accessToken = getAccessToken()

  if (accessToken && isAccessTokenExpired()) {
    if (isRefreshTokenExpired()) {
      if (typeof window !== 'undefined') {
        window.open('/logout')
      }

      throw new Error('refresh token has expired')
    } else {
      let refreshToken = getRefreshToken()

      const url = `${getApiUrl()}/api/refresh-access-token`

      let result

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            Authorization: `Token ${btoa(refreshToken)}`,
          },
        })

        if (!response.ok) {
          const error = await response.json()
          throw error
        }

        result = await response.json()
      } catch (error) {
        console.log(error)
        throw error
      }

      accessToken = result.accessToken
      refreshToken = result.refreshToken

      setAccessToken(accessToken)
      setRefreshToken(refreshToken)
    }
  }

  return accessToken
}
